import PropTypes from 'prop-types';
import containerPropType from './container_prop_type';
var propTypes = {
  children: PropTypes.node.isRequired,
  container: containerPropType,
  disablePortal: PropTypes.bool
};
export default propTypes;